import { AfterViewInit, Component, Inject, Injector, OnInit, Optional, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { OelTypeDialogComponent } from 'src/app/modals/oel-type-dialog/oel-type-dialog.component';
import { OelType } from 'src/app/models/oelType.model';
import { AuthService } from 'src/app/services';
import { CommonService } from 'src/app/services/common.service';
import { GridViewService } from 'src/app/services/grid-view.service';
import { OelTypeService } from 'src/app/services/oel-type.service';
import { ToastService } from 'src/app/services/toast.service';
import { UserService } from 'src/app/services/user.service';
import { RolePermissionObjects } from 'src/app/shared/constants/rolePermissionObjects.constants';
import { segsRouteConfig } from 'src/app/shared/constants/segsRouteConfig.constants';
import { DeleteDialog } from 'src/app/shared/delete-dialog/delete-dialog.component';
import { IFormDialogData } from 'src/app/shared/form/form.component';
import nameOf from 'src/app/shared/form/nameOf.helper';
import { ColumnConfig } from 'src/app/shared/grid/core-grid/columnConfig.model';
import { CoreGridComponent } from 'src/app/shared/grid/core-grid/core-grid.component';
import { GridSettingsService } from 'src/app/shared/grid/core-grid/grid-settings-flyout/grid-settings.service';
import { Lookup } from 'src/app/models/lookup.model';
import { ISearchFieldData } from 'src/app/shared/grid/baseGrid.component';

@Component({
  standalone: false,
  selector: 'app-oel-type',
  templateUrl: './../../shared/grid/core-grid/core-grid.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./../../shared/grid/core-grid/core-grid.component.scss']
})
export class OelTypeComponent extends CoreGridComponent<OelType> implements OnInit, AfterViewInit {

  users: Lookup[] = [];

  constructor(
    private oelTypeService: OelTypeService,
    toastService: ToastService,
    dialog: MatDialog,
    commonService: CommonService,
    authService: AuthService,
    gridViewService: GridViewService,
    gridSettingsService: GridSettingsService,
    private userService: UserService,
    protected injector: Injector,
    @Optional() @Inject(MAT_DIALOG_DATA) public searchFieldData: ISearchFieldData
  ) {
    super(toastService, dialog, commonService, authService, gridViewService, gridSettingsService);
    this.gridService = oelTypeService;
  }

  protected get objectId(): string {
    return RolePermissionObjects.OelType;
  }

  get hasOrgFilter(): boolean {
    return true;
  }

  protected override get isGridViewEnabled(): boolean { return true; }

  ngOnInit(): void {
    this.searchDialogRef = this.injector.get(MatDialogRef<OelTypeComponent>, null);
    super.ngOnInit();
    this.userService.getAll().subscribe(users => this.users = users);
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.loadHeaderData();
  }

  override initializeProperties(): void {
    this.addEntityTitle = 'OEL Type';
    this.searchPlaceholder = 'Search OEL Type';
  }

  override initializeColumns(): void {
    this.additionalActions = [];
    this.columnConfigs = [
      new ColumnConfig<OelType>({
        name: nameOf<OelType>(x => x.name),
        displayName: 'OEL Name'
      }),
      new ColumnConfig<OelType>({
        name: nameOf<OelType>(x => x.description),
        displayName: 'OEL Description'
      }),
      new ColumnConfig<OelType>({
        name: nameOf<OelType>(x => x.referenceTimePeriod),
        displayName: 'Reference Time Period'
      }),
      new ColumnConfig<OelType>({
        name: nameOf<OelType>(x => x.deletedByUserId),
        displayName: 'Deleted By User',
        cellTemplate: (e) => this.users?.find(u => u.id.toString() === e.deletedByUserId)?.name || '-'
      }),
      new ColumnConfig<OelType>({
        name: nameOf<OelType>(x => x.deletedDate),
        displayName: 'Deleted Date'
      }),
      new ColumnConfig<OelType>({
        name: nameOf<OelType>(x => x.isDeleted),
        displayName: 'Is Deleted',
        cellTemplate: (e) => e.isDeleted ? 'Yes' : 'No'
      }),
      { name: 'action', displayName: 'Actions' }
    ]
  }

  override objectFilterMap(propertyName: string): any | undefined {
    switch (propertyName) {
      case nameOf<OelType>(x => x.deletedByUserId): return this.userService;
      default: return undefined;
    }
  }

  override initializeTabs(): any[] {
    return segsRouteConfig;
  }

  override initializeOverviewConfigs(): void {
    this.overviewConfigs = [];
  }

  override getOverviewData(): Observable<void> {
    return of(undefined);
  }

  override openEntityDialog(id?: string): void {
    const oelTypeMediaModel: IFormDialogData = {
      id: id
    }
    this.openDialog(OelTypeDialogComponent, oelTypeMediaModel)
  }

  override openEntityDeleteDialog(entity: OelType): void {
    this.openDeleteDialog(DeleteDialog, entity, this.oelTypeService, 'Media');
  }
}
